import { Box, Button, Heading, List, Text, VStack } from '@chakra-ui/react'

export const TERMS_VERSION = '2026-08-14'

export function TermsAckPanel({ onAccept, isSubmitting }: { onAccept: () => void; isSubmitting: boolean }) {
  return (
    <VStack align="stretch" gap={5} maxW="30rem" mx="auto" p={6}>
      <Heading size="md">Before you start</Heading>
      <Text color="fg.muted">
        You're accessing this walk list as a representative of the campaign, on its behalf.
        By continuing, you agree that:
      </Text>
      <List.Root gap={2} color="fg.muted" ps={4}>
        <List.Item>You'll use this list <b>only for this campaign's canvassing</b> — for no other purpose.</List.Item>
        <List.Item>You <b>won't copy, download, screenshot to share, print, or give</b> this list to anyone else.</List.Item>
        <List.Item>This information stays the <b>property of the campaign and the state</b>; it's provided to you only to do this work.</List.Item>
        <List.Item>Your access can be <b>turned off at any time</b>, and the list on this device <b>expires on its own</b>.</List.Item>
      </List.Root>
      <Button colorPalette="brand" onClick={onAccept} loading={isSubmitting} minH="44px">
        Accept &amp; continue
      </Button>
      <Box fontSize="xs" color="fg.muted">Terms version {TERMS_VERSION}</Box>
    </VStack>
  )
}
